import DOM from '@common/DOM/DOM'

import { is } from '@common/is/is'

import { EModalEvent } from './definitions'
import { getActModalId } from './utils'

/**
 * Bezárja az épp aktuális modalt.
 * @param isForceAnimate - Kényszerített animáció.
 */
export default function closeActualModal (isForceAnimate?: boolean): void {
  const id = getActModalId()

  const modal = document.querySelector(`.sen-modal[id='${ id }']`)

  if (is.null(modal)) {
    return
  }

  if (is.undefined(isForceAnimate)) {
    DOM.dispatch(modal, EModalEvent.Close)

    return
  }

  DOM.dispatch(modal, EModalEvent.Close, false, isForceAnimate)
}
